// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"cca21d47","703":"98156257","787":"722f407c"}[chunkId] + ".chunk.js";
};